import { request } from "services/api/util";

class BroadcastMessageConfigService {
  async getBroadcastMessageConfig() {
    const config = {
      method: "get",
      url: `admin/broadcastMessageConfig`,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
  async setBroadcastMessageConfig(body) {
    let config;
    config = {
      method: "post",
      url: `admin/broadcastMessageConfig`,
      data: body,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
}

export default new BroadcastMessageConfigService();
